module.exports = __webpack_public_path__ + "img/logo-gestionale-auto.d9523ecf.svg";